import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import Input from "../../../components/FormElements/Input";

//
import { updatePasswordSchema } from "../../../utils/schemas/userSchema";
import UserMiddlewares from "../../../store/middlewares/UserMiddlewares";

const UpdatePasswordForm = () => {
  const { t } = useTranslation();
  const form = useForm({
    resolver: yupResolver(updatePasswordSchema),
  });
  const dispatch = useDispatch();
  const { isError, errorMessage } = useSelector(
    (state) => state.user.updatePassword
  );
  const {
    handleSubmit,
    formState: { errors },
    setValue,
  } = form;

  const updatePasswordHandler = async (data) => {
    await dispatch(
      UserMiddlewares.updatePassword(data.newPassword, data.previousPassword)
    );
    setValue("newPassword", "");
    setValue("previousPassword", "");
  };

  return (
    <FormProvider {...form}>
      {isError && <div className="error-message">{errorMessage}</div>}
      <form onSubmit={handleSubmit(updatePasswordHandler)}>
        <Input
          label={t("profile.currentPasswordLabel")}
          id="previousPassword"
          name="previousPassword"
          placeholder=""
          marginBottom="sm"
          error={errors?.previousPassword?.message}
          type="password"
        />
        <Input
          label={t("profile.newPasswordLabel")}
          id="newPassword"
          name="newPassword"
          placeholder=""
          marginBottom="sm"
          error={errors?.newPassword?.message}
          type="password"
          />
        <div className="d-grid gap-2 my-3">
          <button
            type="submit"
            className="btn btn-primary">
              {t("profile.updatePasswordLabel")}
          </button>
        </div>
      </form>
    </FormProvider>
  );
};

export default UpdatePasswordForm;
